import { PostHogProvider } from "posthog-js/react";

/**
 * PostHog initialization (same options as `posthog.init(...)`).
 *
 * Where to configure:
 * - **Secrets:** `frontend/.env.local` (Create React App; file is gitignored)
 *     REACT_APP_POSTHOG_KEY=phc_...
 *     REACT_APP_POSTHOG_HOST=https://eu.i.posthog.com
 * - **Defaults / host / consent schema:** this file — `options` passed to `PostHogProvider`.
 */
export default function AppPosthogProvider({ children }) {
    const apiKey = process.env.REACT_APP_POSTHOG_KEY;
    if (!apiKey) {
        return children;
    }

    return (
        <PostHogProvider
            apiKey={apiKey}
            options={{
                api_host:
                    process.env.REACT_APP_POSTHOG_HOST ||
                    "https://eu.i.posthog.com",
                /** Consent / defaults schema version (PostHog “defaults” bundle). */
                defaults: "2026-01-30",
                capture_pageview: true,
                capture_pageleave: true,
                persistence: "localStorage",
                person_profiles: "identified_only",
            }}
        >
            {children}
        </PostHogProvider>
    );
}
